export enum AnimalType {
  Unknown = 0,
  Sow = 10,
  Gilt = 20,
  Piglet = 30,
  Fattening = 40,
  Cow = 50,
  Calf = 55,
  Goat = 60,
  Boar = 70
}

export enum WeightType {
  Grams = 1,
  Kilograms = 2
}

export enum AnimalGender {
  Unknown = 0,
  Male = 10,
  Female = 20
}

export enum AnimalWeightCategory {
  Unknown = 0,
  Light = 100,
  Medium = 200,
  Heavy = 300
}

export enum AnimalHealthIndicator {
  Green = 10,
  Yellow = 20,
  Red = 30
}

export interface AnimalWeightCategoryInfo {
  unit: WeightType;
  value: number;
}

export enum AnimalTrendDataType {
  WeightBirthed = 1,
  WeightWeaned = 2,
  WeightTenWeeks = 3,
  WeightPerDay = 4,

  SlaughterhouseDataBaconCutlet = 60,
  SlaughterhouseDataWeight = 61,
  SlaughterhouseDataFat = 62,
  SlaughterhouseDataLeanMeat = 63,
  SlaughterhouseDataBelly = 64,
  SlaughterhouseDataHam = 65,
  SlaughterhouseDataSpine = 66,
  SlaughterhouseDataShoulder = 67,
  SlaughterhouseDataMoney = 68,
  MortalityDisease = 69,
  MortalityReason = 70,
  AntibioticsInjections = 71,
  AntibioticFree = 72
}

export const AnimalTrendDataTypeTranslations: Record<AnimalTrendDataType, string> = {
  [AnimalTrendDataType.WeightBirthed]: 'f-animal-trend-WeightBirthed',
  [AnimalTrendDataType.WeightWeaned]: 'f-animal-trend-WeightWeaned',
  [AnimalTrendDataType.WeightTenWeeks]: 'f-animal-trend-WeightTenWeeks',
  [AnimalTrendDataType.WeightPerDay]: 'f-animal-trend-WeightPerDay',

  [AnimalTrendDataType.SlaughterhouseDataBaconCutlet]: 'f-animal-trend-SlaughterhouseDataBaconCutlet',
  [AnimalTrendDataType.SlaughterhouseDataWeight]: 'f-animal-trend-SlaughterhouseDataWeight',
  [AnimalTrendDataType.SlaughterhouseDataFat]: 'f-animal-trend-SlaughterhouseDataFat',
  [AnimalTrendDataType.SlaughterhouseDataLeanMeat]: 'f-animal-trend-SlaughterhouseDataLeanMeat',
  [AnimalTrendDataType.SlaughterhouseDataBelly]: 'f-animal-trend-SlaughterhouseDataBelly',
  [AnimalTrendDataType.SlaughterhouseDataHam]: 'f-animal-trend-SlaughterhouseDataHam',
  [AnimalTrendDataType.SlaughterhouseDataSpine]: 'f-animal-trend-SlaughterhouseDataSpine',
  [AnimalTrendDataType.SlaughterhouseDataShoulder]: 'f-animal-trend-SlaughterhouseDataShoulder',
  [AnimalTrendDataType.SlaughterhouseDataMoney]: 'f-animal-trend-SlaughterhouseDataMoney',
  [AnimalTrendDataType.MortalityDisease]: 'f-animal-trend-MortalityDisease',
  [AnimalTrendDataType.MortalityReason]: 'f-animal-trend-MortalityReason',
  [AnimalTrendDataType.AntibioticsInjections]: 'f-animal-trend-AntibioticsInjections',
  [AnimalTrendDataType.AntibioticFree]: 'f-animal-trend-AntibioticFree'
};
